import React from 'react';
import { AdaptedComponentsContext } from '../../../context/AdaptedComponents';
import { AdaptedComponents } from '../../../types/AdaptedComponents';

export function withAdaptedComponents<TProps>(
  adaptedComponents: AdaptedComponents
) {
  return (Component: React.ComponentClass<TProps>) => (props: TProps) =>
    (
      <AdaptedComponentsContext.Provider value={adaptedComponents}>
        <Component {...props} />
      </AdaptedComponentsContext.Provider>
    );
}
